/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { CoreErrorKey } from '../key/core-error.key';
import { ApplicationError } from '../model/application-error.model';
import { Formatter, FormatterProvider } from '../provider/formatter.provider';

export function parseValue(value: string, formatterKey: string, options?: any): any {
  const formatter: Formatter = FormatterProvider.resolveFormatter(formatterKey, options);
  if (!formatter) {
    throw new ApplicationError({
      key: CoreErrorKey.FORMATTER_NOT_FOUND,
      arguments: { formatterKey },
      message: `Formatter '${formatterKey}' not found`
    });
  }
  return formatter.parse(value);
}
